import React from 'react';

const FileList = ({ files, onDeleteFile, isLoading, isAuthenticated }) => {
  // Helper to determine file icon based on file type
  const getFileIcon = (fileType) => {
    if (fileType.includes('image')) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
      );
    } else if (fileType.includes('pdf')) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      );
    } else if (fileType.includes('word') || fileType.includes('document')) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
      );
    } else {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="13 2 13 9 20 9"></polyline>
        </svg>
      );
    }
  };
  
  // Format file size
  const formatFileSize = (bytes) => {
    if (bytes < 1024) {
      return bytes + ' B';
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + ' KB';
    } else {
      return (bytes / 1024 / 1024).toFixed(2) + ' MB';
    }
  };
  
  // Format upload date
  const formatDate = (timestamp) => {
    if (!timestamp) return 'Unknown date';
    
    const date = new Date(timestamp);
    return date.toLocaleString();
  };
  
  if (!isAuthenticated) {
    return (
      <div className="file-list">
        <h3>Your Files</h3>
        <div className="sign-in-prompt">
          <p>Please sign in to view and manage your files</p>
        </div>
      </div>
    );
  }
  
  if (isLoading) {
    return (
      <div className="file-list">
        <h3>Your Files</h3>
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading files...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="file-list">
      <h3>Your Files</h3>
      
      {files.length === 0 ? (
        <div className="no-files">
          <p>No files uploaded yet. Upload your first file!</p>
        </div>
      ) : (
        <div className="files-grid">
          {files.map((file) => (
            <div key={file.id} className="file-card">
              <div className="file-icon">
                {getFileIcon(file.contentType)}
              </div>
              
              <div className="file-info">
                <h4 className="file-name">{file.name}</h4>
                <p className="file-size">{formatFileSize(file.size)}</p>
                <p className="file-date">Uploaded: {formatDate(file.uploadedAt)}</p>
              </div>
              
              <div className="file-actions">
                <a 
                  href={file.downloadUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="download-button"
                  download
                >
                  Download
                </a>
                
                <button 
                  onClick={() => onDeleteFile(file.id)}
                  className="delete-button"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileList;